export class UserSurveyDto {
  surveyGuid: string;
  surveyTitle: string;
  surveyText: string;
  answers: UserSurveyAnswerDto[];

  constructor(dto?: any) {
    this.surveyGuid = dto?.surveyGuid || '';
    this.surveyTitle = dto?.surveyTitle || '';
    this.surveyText = dto?.surveyText || '';
    this.answers = (dto?.answers || []).map(s => new UserSurveyAnswerDto(s));
  }
}

export class UserSurveyAnswerDto {
  answerId: number;
  answer: string;
  isUserInput: boolean;

  constructor(dto?: any) {
    this.answerId = dto?.answerId || null;
    this.answer = dto?.answer || '';
    this.isUserInput = dto?.isUserInput || false;
  }
}

export class UserSurveyAnswerModel {
  surveyGuid: string;
  answerId: string;
  answerText: string;

  constructor(dto?: UserSurveyAnswerModel) {
    this.surveyGuid = dto?.surveyGuid || '';
    this.answerId = dto?.answerId || '';
    this.answerText = dto?.answerText || '';
  }
}
